import { DownloadBlockProps, UseServer } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { DocumentLinks, Theme } from '@stadionhq-v3/core';
import { DownloadBlock } from '@graphql/__generated__/graphql';
import ContentfulRichTextRenderer from '@components/helpers/contentful-rich-text-render';

const downloadBlockTransform = (
  {
    id,
    title,
    subTitle,
    summary,
    bodyCopy,
    theme,
  }: CleanContentful<DownloadBlock>,
  themeOverride?: Theme
): DownloadBlockProps => ({
  id,
  title,
  summary,
  subtitle: subTitle || undefined,
  theme: themeOverride || (theme as Theme) || undefined,
  bodyCopy: (
    <UseServer>
      <ContentfulRichTextRenderer
        document={{
          json: bodyCopy?.json,
          links: bodyCopy?.links as DocumentLinks,
        }}
        theme={themeOverride || (theme as Theme) || undefined}
      />
    </UseServer>
  ),
});

export default downloadBlockTransform;
